import moment from 'moment'

export const superEgoAppURL = 'https://app.super-ego.info/'
export const marketingPlanURL = 'https://super-ego.info/docs/Super_Ego.pdf'
export const ecbExchangeRatesURL = 'https://www.ecb.europa.eu/stats/policy_and_exchange_rates/euro_reference_exchange_rates/html/index.en.html'

export const parseLocalTime = (string, format = 'DD.MM HH:mm') => moment(string).format(format)

export const parseDateByPattern = (string, pattern = 'YYYY-MM-DD hh:mm:ss.SSS Z') =>
  moment(string, pattern)

export const parseLocalTimeByPattern = (string, format = 'DD.MM.YYYY HH:mm', pattern) =>
  parseDateByPattern(string, pattern).format(format)

export const parseDateHumanized = (date, formatMessage, format) => {
  const parsedDate = moment(date)
  const today = moment()
  const yesterday = moment().subtract(1, 'day')

  if (parsedDate.isSame(today, 'day'))
    return formatMessage({ id: 'page.journal.utils.today' })

  if (parsedDate.isSame(yesterday, 'day'))
    return formatMessage({ id: 'page.journal.utils.yesterday' })

  return parsedDate.format(format)
}

export const currencyCodeMapToSymbol = {
  rur: '₽',
  usd: '$',
  eur: '€',
}

export const currencyIdCodeMap = {
  1: 'rur',
}

export const getCurrencySymbolByCode = (code, map = currencyCodeMapToSymbol) => {
  return map[code] || code
}

export const DEFAULT_CURRENCY_ID = 1
export const getCurrencySymbolById = (id = DEFAULT_CURRENCY_ID) =>
  getCurrencySymbolByCode(currencyIdCodeMap[id])

export const qualificationMap = {
  client: 'qualification.client',
  // intern: 'qualification.intern',
  // partner: 'qualification.partner',
  // official_partner: 'qualification.official_partner',
  // mentor: 'qualification.mentor',
  // business_mentor: 'qualification.business_mentor',
  // lead_shareholder: 'qualification.lead_shareholder',
  // regional_mentor: 'qualification.regional_mentor',
  // international_mentor: 'qualification.international_mentor',
  // top_leader: 'qualification.top_leader',
  // shareholder: 'qualification.shareholder',
  // regional_mentor_first_month: 'qualification.regional_mentor_first_month',
  // shareholder_second_month: 'qualification.shareholder_second_month',
  // shareholder_first_month: 'qualification.shareholder_first_month',
  // top_leader_second_month: 'qualification.top_leader_second_month',
  // top_leader_first_month: 'qualification.top_leader_first_month',
  // international_mentor_first_month: 'qualification.international_mentor_first_month',
  curator: 'qualification.curator',
  organizer: 'qualification.organizer',
  practitioner: 'qualification.practitioner',
  community_ambassador: 'qualification.community_ambassador',
  brend_ambassador: 'qualification.brend_ambassador',
  company_ambassador: 'qualification.company_ambassador',
}

export const canSetGoalByQualification = (currentQualification) => {
  if (!currentQualification)
    return false

  // const disabledList = [
  //   'client',
  //   'intern',
  //   'partner',
  //   'lead_shareholder',
  //   'shareholder',
  // ]

  // if (disabledList.indexOf(currentQualification) === -1) {
  //   return true
  // }

  return false
}

// REGEXs
export const regex = {
  personName: /^[a-zA-Zа-яА-ЯёЁ\.\-]+$/,
  login: /^[A-Za-z0-9](?!.*\.$)(?!.*\-$)(?!.*?\.\.)(?!.*?\-\-)(?!.*?\-\.)(?!.*?\.\-)[A-Za-z\d.-]{0,19}$/,
  phone: /^[0-9\+\-\(\)]+$/,
}

export const AVATAR_PLACEHOLDER = '/resources/images/avatars/default-avatar.svg'

export const prepareFilterBeforeReq = obj => {
  const filter = { ...obj }

  Object.keys(filter).forEach(key => {
    const value = filter[key]

    if (key === 'ids') {
      filter[key] = value.split(',').map(v => {
        return parseInt(v.replace(/\s/g, ''), 10)
      })
    }

    if (key === 'qualifications') {
      if (typeof filter[key] === 'string') {
        filter[key] = [value]
      }
    }

    if (!value && value !== 0) {
      delete filter[key]
    }
  })

  return filter
}

export const createCountFormatter = (few, one, two) => {
  const titles = [one, two, few]

  return number => {
    const cases = [2, 0, 1, 1, 1, 2]

    return titles[
      number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]
    ]
  }
}

export const contactActionTypeMap = {
  leftContacts: 'page.partners.actions.leftContacts',
  meeting: 'page.partners.actions.meeting',
  call: 'page.partners.actions.call',
  downloadedBook: 'page.partners.actions.downloadedBook',
  registeredOnSite: 'page.partners.actions.registeredOnSite',
  boughtProduct: 'page.partners.actions.boughtProduct',
  becamePartner: 'page.partners.actions.becamePartner',
  other: 'page.partners.actions.other',
}

export const eventTypesMap = {
  EventByRemittance: 'finance-events.eventByRemittance',
  EventByReceipt: 'finance-events.eventByReceipt',
  EventByPayment: 'finance-events.eventByPayment',
  EventByWithdrawal: 'finance-events.eventByWithdrawal',
  EventByPayout: 'finance-events.eventByPayout',
  EventByGift: 'finance-events.eventByGift'
}

export const simpleHash = s => {
  let h = 0xdeadbeef

  for (let i = 0; i < s.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    h = Math.imul(h ^ s.charCodeAt(i), 2654435761)
  }

  // eslint-disable-next-line no-bitwise
  return (h ^ (h >>> 16)) >>> 0
}

export const getDeviceId = () => simpleHash(navigator.userAgent)

export const defineProgressColor = percent => {
  if (percent >= 100) {
    return '#01c57d'
  }

  if (percent >= 75) {
    return '#78d16c'
  }

  if (percent >= 50) {
    return '#ffca00'
  }

  if (percent >= 25) {
    return '#f99821'
  }

  return '#ff671c'
}

export const strToFixedFloat = str => str ? parseFloat(parseFloat(str).toFixed(2)) : 0
